import { useContext } from 'react';
import { Button } from '@mui/material';
import { ExitToApp as ExitIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import AuthenticationStateContext from '@/components/App/AppSetup/AuthenticationState/AuthenticationStateContext';
import useLogout from '@/components/App/AppHeader/OptionsMenu/Options/LogoutButton/useLogout';

const LogoutButton = () => {
  const [authenticatedUser] = useContext(AuthenticationStateContext);
  const performLogout = useLogout();

  const isLoggedIn = !!authenticatedUser;
  if (!isLoggedIn) {
    return null;
  }

  const logout = async (): Promise<void> => {
    await performLogout();

    window.location.reload();
  };

  return (
    <Button
      variant="contained"
      onClick={logout}
      startIcon={<ExitIcon />}
      disableElevation
    >
      <FormattedMessage id="error_boundary.fixes.logout_button" />
    </Button>
  );
};

export default LogoutButton;
